module.exports = __webpack_public_path__ + "img/icon_box_2_3.fb1838ca.png";